import React, { useCallback, useEffect, useState } from 'react'
import { TextFieldProps } from '@mui/material/TextField/TextField'
import TextField from '@mui/material/TextField'
import { useField } from 'formik'
import useDebounce from '../../hooks/useDebounce'

type FormikTextFieldProps = TextFieldProps & {
  name: string
  debounce?: number
  hideError?: boolean
}

const FormikTextField: React.FC<FormikTextFieldProps> = ({
  debounce,
  hideError,
  ...props
}) => {
  const [{ onChange, ...field }, { error, touched }, { setValue }] = useField(
    props.name
  )
  const [localValue, setLocalValue] = useState(field.value)
  useEffect(() => {
    setLocalValue(field.value)
  }, [field.value])
  const debouncedHandleChange = useDebounce(val => {
    setValue(val)
  }, debounce || 0)
  const handleChangeLocalValue = useCallback(
    e => {
      setLocalValue(e.target.value)
      if (!debounce) {
        setValue(e.target.value)
      } else {
        debouncedHandleChange(e.target.value)
      }
    },
    [props.name]
  )
  return (
    <TextField
      variant='outlined'
      {...field}
      onChange={handleChangeLocalValue}
      value={localValue}
      error={!!(touched && error)}
      helperText={!hideError && touched && error}
      size='small'
      margin='none'
      fullWidth
      {...props}
      inputProps={{
        ...(props.inputProps || {}),
        className: 'data-hj-allow ' + (props.inputProps?.className || ''),
      }}
    />
  )
}

export default FormikTextField
